<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sftdiF/tc-custom/9783985312689.jpg?1702956970918" alt="This image is the cover for the book The Burgess Animal Book for Children, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Burgess Animal Book for Children, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>When Jenny Wren learns that Peter Rabbit would like to know more about the four-footed friends who share the Green Meadows and Green Forest with him, she encourages him to speak with Old Mother Nature who is only too happy to help. During their "classroom" chats, she not only teaches Peter about Arctic Hare and Antelope Jack but also tells him about such creatures as Flying Squirrel, Mountain Beaver, Pocket Gopher, Grasshopper Mouse, Silvery Bat, Mule Deer, and Grizzly Bear Told with all the warmth and whimsy of Burgess's stories, this engaging book acquaints youngsters with many forms of wildlife and the animals' relationships with one another. The charming collection of entertaining tales is sure to transport today's young readers to the same captivating world of nature that delighted generations of children before them.  (Goodreads)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thornton W. Burgess
      </h2>
      
      <p class="authorDescription body article">Thornton Waldo Burgess (January 17, 1874 – June 5, 1965) was an American conservationist and author of children's stories. Burgess loved the beauty of nature and its living creatures so much that he wrote about them for 50 years in books and his newspaper column, Bedtime Stories. He was sometimes known as the Bedtime Story-Man. By the time he retired, he had written more than 170 books and 15,000 stories for the daily newspaper column.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3cf16b88